import PropTypes from 'prop-types';

/** The return value of `useProjectDownloads`, passed to the download components as one prop. */
export const projectDownloadsShape = PropTypes.shape({
  state: PropTypes.object.isRequired,
  project: PropTypes.object,
  nonExcludedResultsCount: PropTypes.number,
  isLoadingResults: PropTypes.bool,
  canExcludeCompanies: PropTypes.bool,
  downloads: PropTypes.object,
  period: PropTypes.object,
  isDownloadLimitReached: PropTypes.bool,
  isSubscriptionLoading: PropTypes.bool,
  requestBulkExport: PropTypes.func.isRequired,
  bulkExport: PropTypes.shape({
    pendingType: PropTypes.string,
    prefillData: PropTypes.object,
    confirm: PropTypes.func,
    cancel: PropTypes.func
  }).isRequired,
  contactsDownload: PropTypes.shape({
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    requestDownload: PropTypes.func
  }).isRequired
});
